// ── AM I THE PRERENDERER? ────────────────────────────────────────────────────
// react-snap drives a headless Chrome with the user agent "ReactSnap" (its
// `userAgent` default, node_modules/react-snap/index.js), which is the only
// signal a component has that it is being captured rather than used.
//
// WHY ANYTHING NEEDS TO KNOW. Prerendering saves the whole <body>, but
// hydration only attaches to #root. Anything rendered through createPortal to
// document.body therefore lands OUTSIDE the hydrated tree: the captured copy
// stays in the HTML as inert markup with no React behind it, and on load React
// mounts a SECOND, live copy through a fresh portal.
//
// The result is two of everything portalled, the dead one painted on top. That
// is exactly what the language picker did — six buttons in the DOM instead of
// three, and clicking the visible one did nothing at all, because the listener
// was on the copy underneath it.
//
// Portalled overlays are interface, not content: a crawler gains nothing from a
// modal or a floating button, so they simply do not render during the capture
// and are mounted normally the moment a real browser loads the page. No
// hydration mismatch is possible either way, because a portal never takes part
// in matching #root.
export const IS_PRERENDER = typeof navigator !== 'undefined'
  && navigator.userAgent === 'ReactSnap';

export default IS_PRERENDER;
